import React, { useState } from 'react';
import { AreaInput } from 'ui-toolkit';
import { Grid, Button } from 'ui-toolkit';

interface IAddNewCommentProps {
  onSubmit: (newComment: string) => void;
}
export const AddNewComment: React.FC<IAddNewCommentProps> = ({ onSubmit }) => {
  const [comment, setComment] = useState<string | null>(null);

  const onSubmitClick = () => {
    onSubmit(comment || '');
    setComment(null);
  };

  return (
    <Grid>
      <AreaInput placeholder={'Leave a comment'} value={comment} rows={1} onChange={setComment} />
      {!!comment ? (
        <Grid columnCount={2}>
          <Button intent={'primary'} onClick={onSubmitClick}>
            Add comment
          </Button>
        </Grid>
      ) : null}
    </Grid>
  );
};
